

const processError = require('./error-process');

module.exports = (entry) => {
  const needsPublish = !entry.sys.publishedVersion || entry.sys.version > entry.sys.publishedVersion + 1;

  if (!needsPublish) {
    return Promise.resolve(entry);
  }

  return entry.publish().catch(
    processError
  );
};
